<template>
  <div v-show="show">
    <div
      @mouseover="mouseover"
      @mouseout="mouseout"
      class="box"
      :style="{
        top: `${top}px`,
        left: `${left}px`,
        width: `${width}px`,
        height: `${height}px`,
      }"
    >
      <div class="close" @click="close"><i class="el-icon-error"></i></div>
      <slot></slot>
    </div>
  </div>
</template>
<script>
export default {
  name: "MoveWindow",
  props: {
    width: {
      type: Number,
      default: 430,
    },
    height: {
      type: Number,
      default: 305,
    },
  },
  data() {
    return {
      show: true,
      stepX: 2,
      stepY: 2,
      timer: null,
      maxTop: 0,
      maxLeft: 0,
      top: 0,
      left: 0,
    };
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
    // dom 销毁前清除定时器
    clearInterval(this.timer);
  },
  methods: {
    init() {
      this.maxTop = document.documentElement.clientHeight - this.height;
      this.maxLeft = document.documentElement.clientWidth - this.width;
      this.top = 0;
      this.left = 0;
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        this.move();
      }, 20);
      this.onresize();
    },

    // 移动函数

    move() {
      if (this.top >= this.maxTop || this.top < 0) {
        this.stepY = -this.stepY;
      }
      if (this.left >= this.maxLeft || this.left < 0) {
        this.stepX = -this.stepX;
      }
      this.top += this.stepY;
      this.left += this.stepX;
    },

    mouseover() {
      clearInterval(this.timer);
    },

    mouseout() {
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        this.move();
      }, 20);
    },

    close() {
      clearInterval(this.timer);
      this.show = false;
    },

    onresize() {
      const that = this;
      window.onresize = function () {
        that.init();
      };
    },
  },
};
</script>
<style scoped lang="scss">
.box {
  background: red;
  width: 430px;
  height: 305px;
  border-radius: 5px;
  overflow: hidden;
  position: fixed;
  z-index: 999;
  text-align: left;
  color: #ffffff;
  top: 0;
  left: 0;
  &:hover {
    .close {
      display: block;
    }
  }
  .close {
    position: absolute;
    right: 10px;
    top: 10px;
    color: #fefefe;
    cursor: pointer;
    display: none;
  }
}
</style>
